<template lang="pug">
  canvas.rotate(ref="canvas" :width="containWidth" :height="containHeight")
</template>

<script>
  export default {
    name: "rotate",
    props: {
      points: {
        type: Array,
        default: () => [
          [
            {x: 111, y: 447, arc: 3},
            {x: 99, y: 483, arc: 3},
            {x: 132, y: 507, arc: 3},
            {x: 163, y: 485, arc: 3},
            {x: 152, y: 448, arc: 3},
          ]
        ]
      },
      iterTimes: {
        type: Array,
        default: () => [500],
      }
    },
    data() {
      return {
        ctx: null,
        targetPointsList: null,
        targetRadians: null,
        iterNum: 0,
      };
    },
    watch: {},
    computed: {
      containHeight() {
        return 600;
      },
      containWidth() {
        return window.innerWidth;
      },
      center() {
        return this.points.map(item => item.reduce((a, b) => {
          return {
            x: a.x + b.x,
            y: a.y + b.y,
          }
        }).map(point => {
          return {
            x: point.x / item.length,
            y: point.y / item.length
          }
        }))
      },
      targetRadian() {
        const random = () => Math.random() * 2 * Math.PI - Math.PI;
        if (this.iterNum === 0) {
          this.targetRadians = this.points.map(() => random());
        }
        for (let i = 0; i < this.iterTimes.length; i++) {
          if (this.iterNum % this.iterTimes[i] === 0) {
            this.targetRadians.splice(i, 1, random());
          }
        }
        return this.targetRadians;
      },
      target() {
        return this.points.map(item => item.map(point => {
          const index = this.points.findIndex(item);
          return {
            ...point,
            x: Math.cos(this.targetRadian[index]) * (point.x - this.center[index].x)
                - Math.sin(this.targetRadian[index]) * (point.y - this.center[index].y),
            y: Math.sin(this.targetRadian[index]) * (point.x - this.center[index].x)
                + Math.cos(this.targetRadian[index]) * (point.y - this.center[index].y),
          }
        }))
      },
    },
    methods: {
      move() {
        this.iterNum++;
      },
      draw() {
        const target = this.target;
        const ctx = this.ctx;
        ctx.fillStyle = '#2abeff';
        ctx.strokeStyle = '#2abeff';
        for (let i = 0; i < target.length; i++) {
          for (let j = 0; j < target[i].length; j++) {
            const point = target[i][j];
            ctx.beginPath();
            ctx.arc(point.x, point.y, point.arc, 0, 2*Math.PI);
            ctx.fill();
            
            ctx.beginPath();
            ctx.lineTo(target[i][(j + 1) % target[i].length].x, target[i][(j + 1) % target[i].length].y);
            ctx.lineTo(point.x, point.y);
            ctx.stroke();
          }
        }
      },
      animate() {
        this.ctx.clearRect(0, 0, this.containWidth, this.containHeight);
        this.move();
        this.draw();
        window.requestAnimationFrame(this.animate);
      },
    },
    created() {
    },
    mounted() {
      this.ctx = this.$refs.canvas.getContext('2d');
      this.animate();
    },
  };
</script>

<style scoped lang="stylus">
  .rotate {
  
  }
</style>
